import { useLanguage } from '../../../context/LanguageContext';

export default function Footer() {
  const { language, setLanguage, t } = useLanguage();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1A2B4A] text-white relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url('data:image/svg+xml,<svg width="100" height="100" xmlns="http://www.w3.org/2000/svg"><path d="M50 10 L90 50 L50 90 L10 50 Z" fill="none" stroke="white" stroke-width="0.5"/></svg>')`,
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-8 py-20 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-16 pb-8 border-b border-white/10">
          <div className="flex items-center gap-1 mb-6 md:mb-0">
            <span className="text-2xl font-serif font-bold">TS Consulting</span>
            <span className="w-2 h-2 rounded-full bg-[#C9A961]"></span>
          </div>
          <div className="flex gap-8">
            <button
              onClick={() => scrollToSection('services')}
              className="text-white/80 hover:text-white transition-colors cursor-pointer"
            >
              {t('Services')}
            </button>
            <button
              onClick={() => scrollToSection('regions')}
              className="text-white/80 hover:text-white transition-colors cursor-pointer"
            >
              {t('Regions')}
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-white/80 hover:text-white transition-colors cursor-pointer"
            >
              {t('nav.about')}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-white/80 hover:text-white transition-colors cursor-pointer"
            >
              {t('Contact')}
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
          <div>
            <h3 className="text-lg font-bold mb-5">{t('footer.aboutHeading')}</h3>
            <p className="text-white/70 text-sm leading-relaxed max-w-sm">
              {t('footer.aboutText')}
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-5">{t('footer.quickLinks')}</h3>
            <div className="grid grid-cols-2 gap-x-8 gap-y-3">
              <a href="#services" className="block text-white/70 text-sm hover:text-white transition-colors">
                {t('services.card1Title')}
              </a>
              <a href="#services" className="block text-white/70 text-sm hover:text-white transition-colors">
                {t('services.card2Title')}
              </a>
              <a href="#services" className="block text-white/70 text-sm hover:text-white transition-colors">
                {t('services.card3Title')}
              </a>
              <a href="#contact" className="block text-white/70 text-sm hover:text-white transition-colors">
                {t('contact.scheduleButton')}
              </a>
              <a href="#about" className="block text-white/70 text-sm hover:text-white transition-colors">
                {t('footer.about')}
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-[#C9A961]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
            <p className="text-white/60 text-sm">{t('footer.copyright')}</p>
            <div className="flex items-center gap-6">
              <a href="/privacy-policy" className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer">
                {t('footer.privacyPolicy')}
              </a>
              <span className="text-[#C9A961]">|</span>
              <a href="/terms-of-service" className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer">
                {t('footer.termsOfService')}
              </a>
              <span className="text-[#C9A961]">|</span>
              <a href="/cookie-policy" className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer">
                {t('footer.cookiePolicy')}
              </a>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <button
                onClick={() => setLanguage('en')}
                className={`transition-colors cursor-pointer ${
                  language === 'en' ? 'text-white font-bold' : 'text-white/60 hover:text-white'
                }`}
              >
                EN
              </button>
              <span className="text-white/60">|</span>
              <button
                onClick={() => setLanguage('et')}
                className={`transition-colors cursor-pointer ${
                  language === 'et' ? 'text-white font-bold' : 'text-white/60 hover:text-white'
                }`}
              >
                ET
              </button>
            </div>
          </div>
          
          <div className="text-center pt-4 border-t border-white/10">
            <p className="text-white/50 text-xs">
              Powered by{' '}
              <a 
                href="https://lumenat.io" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#C9A961] hover:text-[#B89851] transition-colors cursor-pointer"
              >
                Lumenatio
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}